import { render, staticRenderFns } from "./edit-questionnaire.vue?vue&type=template&id=1177db8c"
import script from "./edit-questionnaire.vue?vue&type=script&lang=js"
export * from "./edit-questionnaire.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports